import { create } from "../../../common/utils/zustand_state_manager";
import { IGestaoEpiService } from "../../../features/gestaoEpi/data/services/gestao_epi_service";
import { GestaoEpiService } from "../../../features/gestaoEpi/data/services/gestao_epi_service_impl";


/**
 * useGestaoEPIServices
 */

type State = {
  gestaoEPIService: IGestaoEpiService,
};

export const useGestaoEPIServices = create<State>((set, get) => ({
  gestaoEPIService: new GestaoEpiService(),
}));